// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var MM_context = require("../mm-utils/MM_context.bs.js");
var MM_cmp_pe_asrt_list = require("./MM_cmp_pe_asrt_list.bs.js");

function propsAreSame(a, b) {
  if (a.settingsVer === b.settingsVer) {
    return a.preCtxVer === b.preCtxVer;
  } else {
    return false;
  }
}

var make = React.memo((function (param) {
        var preCtx = param.preCtx;
        var preCtxVer = param.preCtxVer;
        var settingsVer = param.settingsVer;
        var match = React.useState(function () {
              return [];
            });
        var setAllLabels = match[1];
        var match$1 = React.useState(function () {
              return [];
            });
        var setFilteredLabels = match$1[1];
        var match$2 = React.useState(function () {
              return 0;
            });
        var setFilteredLabelsVer = match$2[1];
        var actCtxChanged = function (param) {
          var allLabels = MM_context.getAllFrameLabels(preCtx).map(function (label, i) {
                return [
                        i + 1 | 0,
                        label
                      ];
              });
          Curry._1(setAllLabels, (function (param) {
                  return allLabels;
                }));
          Curry._1(setFilteredLabels, (function (param) {
                  return allLabels;
                }));
          Curry._1(setFilteredLabelsVer, (function (prev) {
                  return prev + 1 | 0;
                }));
        };
        React.useEffect((function () {
                
              }), [settingsVer]);
        React.useEffect((function () {
                actCtxChanged(undefined);
              }), [preCtxVer]);
        return React.createElement(MM_cmp_pe_asrt_list.make, {
                    settingsVer: settingsVer,
                    settings: param.settings,
                    preCtxVer: preCtxVer,
                    preCtx: preCtx,
                    labelsVer: match$2[0],
                    labels: match$1[0]
                  });
      }), propsAreSame);

exports.propsAreSame = propsAreSame;
exports.make = make;
/* make Not a pure module */
